export const COMPONENT_LOADING_TIMEOUT_MS = 30_000;
export const ACTION_COMPONENT_LOAD_START = 'ComponentLoadStart';
export const ACTION_COMPONENT_LOAD_END = 'ComponentLoadEnd';
